import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import { Card } from './ui/card';
import { FileText, Pill, User as UserIcon, Stethoscope } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PatientNotesView = () => {
  const { t } = useLanguage();
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    axios.get(`${API}/notes`, { withCredentials: true })
      .then(r => setNotes(r.data))
      .catch(() => {});
  }, []);

  if (notes.length === 0) {
    return (
      <Card className="p-8 text-center" data-testid="patient-no-notes">
        <FileText className="mx-auto text-gray-400 mb-3" size={48} />
        <p className="text-gray-600">{t('لا توجد وصفات أو ملاحظات بعد', 'No prescriptions or notes yet', 'Aucune ordonnance pour le moment')}</p>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {notes.map((n) => (
        <Card key={n._id} className="p-5" data-testid={`patient-note-${n._id}`}>
          <div className="flex items-start gap-3 mb-3">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${n.author_role === 'pharmacist' ? 'bg-purple-100' : 'bg-blue-100'}`}>
              {n.author_role === 'pharmacist' ? (
                <Pill size={20} className="text-purple-600" />
              ) : (
                <Stethoscope size={20} className="text-[#1e88e5]" />
              )}
            </div>
            <div className="flex-1">
              <p className="font-semibold text-[#2c3e50]">{n.author_name}</p>
              <p className="text-xs text-gray-500">
                {n.author_role === 'pharmacist' ? t('صيدلي', 'Pharmacist', 'Pharmacien') : t('طبيب', 'Doctor', 'Médecin')}
                {' • '}
                {new Date(n.created_at).toLocaleString()}
              </p>
            </div>
          </div>
          {n.medications && (
            <div className="bg-blue-50 rounded-lg p-3 mb-2 text-sm">
              <span className="font-semibold">{t('الأدوية:', 'Medications:', 'Médicaments:')}</span> {n.medications}
            </div>
          )}
          {n.dosage && (
            <div className="bg-blue-50 rounded-lg p-3 mb-2 text-sm">
              <span className="font-semibold">{t('الجرعة:', 'Dosage:', 'Posologie:')}</span> {n.dosage}
            </div>
          )}
          <p className="text-gray-700 whitespace-pre-wrap text-sm leading-relaxed">{n.notes}</p>
        </Card>
      ))}
    </div>
  );
};
